<div class="content-container margin-bottom">
  <div class="controls margin-sm-bottom">
    <div class="left-controls">
      <div class="filters">
        <app-filter-editor [formControl]="filterControl"
          [chips]="['user', 'status', 'effort', 'project', 'reportsto.hawkid', 'dept', 'dept(owners)']"
          label="Filter timesheet submissions - search by attribute or type freely to search all."
          [selectedFilters]="(selectedFilters | async) || []" (filterChange)="filterChange($event)"
          [chipPossVals]="chipPossVals" [chipHelpers]='chipHelpers' class="filter-editor">
        </app-filter-editor>

        <button mat-stroked-button (click)="clear()">
          <mat-icon class="material-symbols-outlined">clear</mat-icon>
          Clear
        </button>
        <button mat-icon-button class="outlined-icon-button" (click)="addQuery()" title="Show a dialog to save this filter with a name..."><mat-icon>save</mat-icon></button>
        <!-- <button mat-stroked-button (click)="pinFilter()">
          <mat-icon class="material-symbols-outlined">keep</mat-icon>
          ...
        </button> -->
      </div>
    </div>

    <div class="right-controls">
      <div class="date-range-controls">
      <mat-form-field class="date-range-form-field">
        <mat-label for="dateRangePicker">Enter a date range</mat-label>
        <mat-date-range-input id="dateRangePicker" [rangePicker]="rangePicker" [formGroup]="rangeForm">
          <mat-label for="startDate">startDate</mat-label>
          <input id="startDate" matStartDate aria-label="Start Date" placeholder="Start Date" formControlName="start" />
          <mat-label for="endDate">endDate</mat-label>
          <input id="endDate" matEndDate aria-label="End Date" placeholder="End date" formControlName="end" />
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-datepicker-toggle matSuffix (click)="rangeForm.reset()">
          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
        </mat-datepicker-toggle>
        <!-- #docregion date-range-picker-actions -->
        <mat-date-range-picker #rangePicker>
          <!-- <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel>Cancel</button>
              <button mat-raised-button matDateRangePickerApply>Apply</button>
            </mat-date-range-picker-actions> -->
        </mat-date-range-picker>
        <!-- #enddocregion date-range-picker-actions -->
      </mat-form-field>
      <div class="saved-queries date-range-shortcuts">
        <mat-chip-set aria-label="Date range shortcuts">
          @for (preset of dateRangePresets; track preset.key) {
            @let selected = selectedDateRangePreset === preset.key;
            <mat-chip
              class="date-range-chip"
              [class.is-selected]="selected"
              [title]="'Set date range to ' + preset.label"
              (click)="setDateRangePreset(preset.key)">
              @if (selected) {
                <mat-icon class="range-selected-icon">check</mat-icon>
              }
              {{ preset.label }}
            </mat-chip>
          }
        </mat-chip-set>
      </div>
      </div>
      <!-- <div class=""
      <a (click)="setCurrentMonth()">This month</a>
      <a (click)="setPreviousMonth()">Last month</a> -->
    </div>
    <div *ngIf="1 > 0" class="saved-queries">
      <div style="margin-right: 1em; ">Saved Filters:</div>
      <mat-chip-set aria-label="Unsubmitted timesheets">
        @for (query of userQueryStrings; track query[0]) {
        @let name = query[0];
        @let queryString = query[1];
        <mat-chip [class]="'saved-queries query-' + name" [title]="'Click to restore filter named \'' + name + '.\''" (click)="setQuery(queryString)"
          (removed)="removeQuery(name)">
          {{ name }}
          <button matChipRemove aria-label]="Remove saved query." *ngIf="queryString !== true">
            <mat-icon>close</mat-icon>
          </button>
        </mat-chip>
        }
      </mat-chip-set>
      <!-- <button mat-mini-fab (click)="addQuery()"><mat-icon>add</mat-icon></button> -->
    </div>
  </div>

  @if (isPrivilegedUser && ! hasFilterReportsTo) {
  <mat-card appearance="outlined" class="timesheet-status">
    <mat-card-content>
      <p class="margin-top-none">
        <b>Caution:</b> as a privileged user, you have access to the timesheets of users who don't necessarily report to
        you.
      </p>
    </mat-card-content>
  </mat-card>
  }
</div>
<section class="timesheet-viewer">
  <div class="timesheet-viewer-tool-row">
    <div style="display: flex; gap: 1em; align-items: center;">
      <mat-button-toggle-group [formControl]="timesheetViewMode" aria-label="Timesheet View Mode" #viewModeToggle>
        <mat-button-toggle value="by-week">By Week</mat-button-toggle>
        <mat-button-toggle value="by-person">By Person</mat-button-toggle>
        <mat-button-toggle value="flat">No Grouping</mat-button-toggle>
      </mat-button-toggle-group>
      <mat-slide-toggle [formControl]="autoAdjustPageSize"
        title="Adjusts the page size according to your filter parameters, if possible (especially selected date range, # of reports for reportsto.hawkid, etc).">
        Auto Page Size
      </mat-slide-toggle>
    </div>
    <div style="display: flex; gap: 1em; margin-left: auto !important;">
    <button mat-stroked-button (click)="sendReminders()" style="margin-left: auto !important;">Send Reminders</button>
    <button mat-stroked-button (click)="startExport()">
      <mat-icon>download</mat-icon>
      Export
    </button>
    </div>
  </div>
  <app-tree-grid [nodes]="treeNodes" [rootLabel]="'Employee / Effort → Project'" [levelColumns]="viewModeColumns"
    [class.flattened]="timesheetViewMode.value === 'flat'" matSort>
    <ng-template [treeHeaderTemplate]="'level0-label'" let-node="node" let-header="header">
      <div mat-sort-header [mat-sort-header]="node?.value.sortKey">{{ header }}</div>
    </ng-template>

    <ng-template [treeCellTemplate]="'level0-label'" let-node="node">
      <div class="grid-header">
        {{ node.label }}
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'level1-label'" let-node="node">
      <div class="grid-header">
        {{ node.label }}
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'eff-proj-label'" let-node="node">
      <div class="timesheet-project">
        {{ node.label }}
        @if (node.timeType == 'Billable') {
        <!-- <div class="time-type">$&nbsp;&times;</div> -->
         <div class="time-type" title="These hours are billable."><mat-icon class="material-symbols-outlined">check</mat-icon></div>
        }
      </div>
    </ng-template>
    <ng-template [treeHeaderTemplate]="'eff-proj-label'" let-node="node" let-header="header">
      <div class="timesheet-project">
        Effort :: Project
        <span class="time-type-label">Billable</span>
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'hours'" let-node="node">
      <div class="project-total-hours">
        {{ node.hours | number: '1.0-2' }}
        <!-- @if (node.timesheet.status == 'Review') {
        <mat-checkbox aria-label="employee review selection" [(ngModel)]="node.isPleaseReview">
          Please review.
        </mat-checkbox>
        } -->
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'level0-summary'" let-node="node">
      <div class="vertical-center">
        {{ node.children.length | i18nPlural: { '=1': '1 timesheet', 'other': '# timesheets' } }}
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'status'" let-node="node">
      <div [class.approved-status]="node.status === 'Approved'" [class.review-status]="node.status === 'Review'"
        [class.unsubmitted-status]="node.status === 'Unsubmitted'" class="vertical-center">
        @let currentStatus = tsShadowOf(node.timesheet)?.status;
        @let proposedStatus = node.timesheet?.status ?? 'Unsubmitted';
        @if (currentStatus == proposedStatus) {
        <span>
          {{ proposedStatus }},
        </span>
        } @else {
        <span class='proposed-change-from'>{{currentStatus}}</span> &rarr; <span class='proposed-change'>{{
          proposedStatus }},</span>
        }
        {{ node.hours | number: '1.0-2' }} hours
        @if (node.timesheet?.officialLeaveUnavailable) {
          &nbsp;<strong class="official-leave-unavailable"
            title="Official leave could not be loaded, so these hours may be missing leave. Reload to try again.">(leave unavailable)</strong>
        }
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'approval'" let-node="node">
      <div class="timesheet-approval vertical-center">
        <mat-button-toggle-group [(ngModel)]="node.timesheet.status" [disabled]="node.timesheet.status == 'Unsubmitted'"
          (change)="updateApproval(node, $event.value)">
          <mat-button-toggle value="Approved">Approve</mat-button-toggle>
          <mat-button-toggle value="Review">Return</mat-button-toggle>
        </mat-button-toggle-group>

      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'hoursByDay'" let-node="node">
      <div class="week-of-hours">
        @let isReviewMode = node.timesheet?.status == 'Review';
        @for (hours of node.hoursByDay; track hours; let i = $index) {
        @let title = hours.isImported
        ? 'Imported from approved official leave records. Complete leave in the official leave application.'
        : !isReviewMode
        ? (hours.hasNotes ? 'Notes: ' + hours.notes : '[No notes]')
        : 'Click to call out these hours as needing review.\n\nNotes: ' + (hours.notes || '[No notes]');
        <div class="hours-by-day" [style.--day]="i" [class.has-notes]="hours.hasNotes" [title]="title">
          @if (isReviewMode && hours.value && !hours.isImported) {
          <button mat-mini-fab class="hours-review-marker" [class.is-review]="isReview(node, i)"
            (click)="toggleReview(node, i)">
            @if (hours.value) {
            {{ hours.value | number: '1.0-2' }}
            } @else {
            -
            }
          </button>
          } @else {
          @if (hours.value) {
          {{ hours.value | number: '1.0-2' }}
          } @else {
          -
          }
          }
        </div>
        }
      </div>
    </ng-template>
    <ng-template [treeHeaderTemplate]="'hoursByDay'" let-node="node" let-header="header">
      <div class="week-of-hours">
        @for (title of header; track title; let i = $index) {
        <div class="hours-by-day" [style.--day]="i">
          {{ title }}
        </div>
        }
      </div>
    </ng-template>
    <ng-template [treeFooterTemplate]="'hoursByDay'" let-node="node" let-footer="footer">
      <div class="week-of-hours">
        @for (day of footer.value; track day; let i = $index) {
        <div class="hours-by-day" [style.--day]="i">
          {{ totalForDay(node, i) | number: '1.0-2' }}
        </div>
        }
      </div>
    </ng-template>
    <ng-template [treeFooterTemplate]="'eff-proj-label'" let-node="node">
      <div class="project-total-hours">
        Daily Totals
      </div>
    </ng-template>
    <ng-template [treeFooterTemplate]="'hours'" let-node="node" let-footer="footer">
      <div class="weekly-total-hours">
        {{ node.hours | number: '1.0-2' }}
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'date'" let-node="node">
      <div class="notes-date">
        {{ node.label }}:
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'time-details'" let-node="node">
      <div class="time-details vertical-center">
        {{ node.hours | number: '1.0-2'}} hours
        @if (node.notes) {
        &mdash;
        <span class='notes'>&ldquo;{{ node.notes }}&rdquo;</span>
        }
      </div>
    </ng-template>
    <ng-template [treeFooterTemplate]="'timesheet-tools'" let-node="node">
      @let currentStatus = tsShadowOf(node.timesheet)?.status;
      @let proposedStatus = node.timesheet?.status ?? 'Unsubmitted';
      <div class="timesheet-tools vertical-center" *ngIf="currentStatus != proposedStatus">
        <mat-form-field *ngIf="node.timesheet.status != 'Approved'">
          <mat-label>Comments for {{ node.timesheet.owner?.displayName }}</mat-label>
          <textarea matInput [(ngModel)]="node.timesheet.reviewerComments"></textarea>
        </mat-form-field>
        <button mat-stroked-button (click)="resetTimesheetChoice(node)">
          Cancel
        </button>
        <button mat-flat-button (click)="saveChoice(node.timesheet)" color="primary">
          Confirm {{ node.timesheet.status == 'Approved' ? 'approval' : 'return for review' }}
        </button>
      </div>
    </ng-template>
    <ng-template [treeCellTemplate]="'please-review'" let-node="node">
      <div class="please-review-cell vertical-center">
        @if (node.timesheet?.status == 'Review' && !isOfficialLeaveProject(node.timeEntry.project)) {
        <mat-checkbox aria-label="employee review selection" [(ngModel)]="node.timeEntry.isPleaseReview">
          Please review.
        </mat-checkbox>
        }
      </div>
    </ng-template>

    <!-- Empty results -->
    <ng-template [treeEmptyResultsTemplate]="'empty-results'">
      No timesheets match the current filter.
    </ng-template>
  </app-tree-grid>
  <div class="bottom-tools">
    <mat-paginator [pageSizeOptions]="[10, 15, 20, 30, 40, 50, 75, 100]" showFirstLastButtons [pageSize]="20"
      [length]="totalEntries">
    </mat-paginator>
  </div>
  <div class="loading-data" [class.showing]="isLoading | async">
    <mat-spinner></mat-spinner>
  </div>
</section>
